import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'calculateTotalSummary',
  standalone: true,
})
export class CalculateTotalSummaryPipe implements PipeTransform {
  transform(balance: any, currency: string): number {
    return parseFloat(balance[currency]);
  }
}
